import { deleteField, doc, increment, updateDoc } from "firebase/firestore";
import { db } from "./firebase";
import toasted from "../config/toasted";
import { Bolt, CalendarMonth, WorkspacePremium } from "@mui/icons-material";





// share prompt with totalEarnings 
export const inShareUniversal = async (txt, userData, promptId) => {

      const uid = userData?.uid;

      if (!userData) {

            try {
                  await navigator.share({ text: txt });
                  toasted.success("Shared successfully");
            } catch (err) {
                  // ❌ User pressed Cancel → ignore silently
                  if (err.name !== "AbortError") {
                        console.error(err);
                        toasted.error("Something went wrong while sharing.");
                  }
            }
            return
      }


      if (!navigator.share) {
            return toasted.error("Sharing not supported here.");
      }

      try {
            // Share the text
            await navigator.share({ text: txt });

            // References
            const promptRef = doc(db, "prompts", promptId);
            const userRef = doc(db, "users", uid);


            // Update both in parallel (faster than awaiting one after the other)
            await Promise.all([
                  updateDoc(promptRef, { share: increment(1) }),
                  updateDoc(userRef, { totalEarnings: increment(1) }),
            ]);

            toasted.success("Shared successfully");
      } catch (err) {
            if (err.name !== "AbortError") {
                  console.error(err);
                  toasted.error("Something went wrong while sharing.");
            }
      }
};


// 
export const getPlanIcon = (title) => {
  switch (title) {
    case "3 Months":
      return <WorkspacePremium />; 
    case "1 Months":
      return <CalendarMonth />;
    case "7 days":
      return <Bolt />;
    default:
      return <CalendarMonth />;
  }
};




export const checkAndExpirePlan = async (userData) => {
     try {
          if (!userData?.uid) return;

          const expiryAt = userData?.planDetails?.expiryAt;
          if (!expiryAt) return;

          const expiryTime = new Date(expiryAt).getTime();
          if (Number.isNaN(expiryTime)) return;

          const isExpired = Date.now() > expiryTime;

          if (!isExpired) return;

          await updateDoc(doc(db, 'users', userData.uid), {
               subscriptions: 'expired',
               isPremium: false,
               message: 'Your subscription has expired. Please renew to continue premium access.',
               planDetails: deleteField(),
          });
     } catch (error) {
          console.error('checkAndExpirePlan error:', error);
     }
};